var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSonarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220,
    zoomAndPan: "magnify",
    viewBox: "0 0 165 44.999999",
    height: 60,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "0c168f6d10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21 28 L 37 28 L 37 43 L 21 43 Z M 21 28 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4638df326c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6431b6e653"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "749527c10c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 20 L 39 20 L 39 27 L 20 27 Z M 20 20 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f36ab98088"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17006f71c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "287020fb05"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 16 L 43 16 L 43 24 L 16 24 Z M 16 16 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "89ad17ff45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6f571ec3f7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a344afdd94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12 11 L 47 11 L 47 22 L 12 22 Z M 12 11 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d3e9c3a295"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed08a4cd5b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cc347f5a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 7 L 51 7 L 51 20 L 8 20 Z M 8 7 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "995dea317b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4425d1d27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "44ce5f6008"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 3 L 55 3 L 55 17 L 4 17 Z M 4 3 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eae3e5904d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f37063b3c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.371094 19.042969 L 29.335938 -8.917969 L 57.015625 18.761719 L 29.050781 46.722656 Z M 1.371094 19.042969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e140d27e8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.484375 15.933594 L 29.324219 -8.90625 L 54.757812 16.53125 L 29.921875 41.367188 Z M 4.484375 15.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58e028a22c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 99,
    y: 0,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 34, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58e028a22c)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.450829, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 8.140625 0.359375 C 5.003906 0.359375 2.550781 -0.738281 0.78125 -2.9375 L 3.53125 -5.6875 C 4.726562 -4.144531 6.289062 -3.375 8.21875 -3.375 C 10.21875 -3.375 11.21875 -4.253906 11.21875 -6.015625 C 11.21875 -6.734375 11.035156 -7.289062 10.671875 -7.6875 C 10.316406 -8.082031 9.757812 -8.359375 9 -8.515625 L 7.09375 -8.875 C 5.15625 -9.238281 3.734375 -9.910156 2.828125 -10.890625 C 1.921875 -11.878906 1.46875 -13.253906 1.46875 -15.015625 C 1.46875 -17.046875 2.0625 -18.585938 3.25 -19.640625 C 4.445312 -20.703125 6.203125 -21.234375 8.515625 -21.234375 C 11.472656 -21.234375 13.71875 -20.273438 15.25 -18.359375 L 12.5 -15.609375 C 11.976562 -16.242188 11.394531 -16.71875 10.75 -17.03125 C 10.101562 -17.34375 9.34375 -17.5 8.46875 -17.5 C 7.507812 -17.5 6.8125 -17.316406 6.375 -16.953125 C 5.945312 -16.597656 5.734375 -16.019531 5.734375 -15.21875 C 5.734375 -14.519531 5.898438 -13.988281 6.234375 -13.625 C 6.566406 -13.269531 7.097656 -13.015625 7.828125 -12.859375 L 9.75 -12.46875 C 10.769531 -12.25 11.640625 -11.984375 12.359375 -11.671875 C 13.085938 -11.367188 13.6875 -10.976562 14.15625 -10.5 C 14.625 -10.019531 14.960938 -9.453125 15.171875 -8.796875 C 15.378906 -8.140625 15.484375 -7.367188 15.484375 -6.484375 C 15.484375 -4.253906 14.851562 -2.554688 13.59375 -1.390625 C 12.34375 -0.222656 10.523438 0.359375 8.140625 0.359375 Z M 8.140625 0.359375 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.077413, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.41656, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.755707, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.094854, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.435452, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.59375 -11.1875 L 6.28125 -14.5 L 5.796875 -14.5 L 6.046875 -11 L 6.046875 0 L 2.03125 0 L 2.03125 -20.875 L 6.703125 -20.875 L 11.96875 -9.6875 L 13.28125 -6.375 L 13.75 -6.375 L 13.515625 -9.875 L 13.515625 -20.875 L 17.53125 -20.875 L 17.53125 0 L 12.859375 0 Z M 7.59375 -11.1875 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.991126, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 13.671875 0 L 12.375 -5.109375 L 5.984375 -5.109375 L 4.6875 0 L 0.59375 0 L 6.515625 -20.875 L 11.96875 -20.875 L 17.890625 0 Z M 10.046875 -13.375 L 9.390625 -16.984375 L 8.90625 -16.984375 L 8.25 -13.375 L 7.03125 -8.546875 L 11.328125 -8.546875 Z M 10.046875 -13.375 "
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#efefef",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.470341, 42.72486)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 6.3125 0 L 2.03125 0 L 2.03125 -20.875 L 11.0625 -20.875 C 12.9375 -20.875 14.363281 -20.285156 15.34375 -19.109375 C 16.320312 -17.929688 16.8125 -16.359375 16.8125 -14.390625 C 16.8125 -12.847656 16.519531 -11.546875 15.9375 -10.484375 C 15.363281 -9.429688 14.507812 -8.695312 13.375 -8.28125 L 17.015625 0 L 12.375 0 L 9.15625 -7.890625 L 6.3125 -7.890625 Z M 10.53125 -11.453125 C 11.101562 -11.453125 11.550781 -11.597656 11.875 -11.890625 C 12.207031 -12.179688 12.375 -12.679688 12.375 -13.390625 L 12.375 -15.1875 C 12.375 -15.90625 12.207031 -16.410156 11.875 -16.703125 C 11.550781 -16.992188 11.101562 -17.140625 10.53125 -17.140625 L 6.3125 -17.140625 L 6.3125 -11.453125 Z M 10.53125 -11.453125 "
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0c168f6d10)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4638df326c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6431b6e653)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M 29.9375 28.074219 C 33.890625 28.53125 36.726562 32.105469 36.269531 36.0625 C 35.8125 40.015625 32.234375 42.851562 28.28125 42.394531 C 24.324219 41.9375 21.492188 38.359375 21.949219 34.40625 C 22.40625 30.449219 25.980469 27.617188 29.9375 28.074219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#749527c10c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f36ab98088)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17006f71c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M 20.191406 25.609375 C 21.09375 24.015625 22.53125 22.699219 24.210938 21.824219 C 25.890625 20.933594 27.828125 20.507812 29.746094 20.570312 C 31.664062 20.648438 33.570312 21.183594 35.1875 22.183594 C 36.808594 23.171875 38.152344 24.582031 38.941406 26.234375 C 37.582031 25.015625 36.128906 24.042969 34.570312 23.363281 C 33.011719 22.703125 31.359375 22.316406 29.6875 22.273438 C 26.335938 22.132812 23.039062 23.347656 20.191406 25.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#287020fb05)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#89ad17ff45)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6f571ec3f7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M 16.234375 23.394531 C 17.582031 21.222656 19.539062 19.378906 21.855469 18.148438 C 24.160156 16.882812 26.8125 16.261719 29.453125 16.277344 C 32.09375 16.296875 34.730469 16.980469 37.023438 18.261719 C 39.328125 19.519531 41.246094 21.414062 42.554688 23.601562 C 39.109375 19.839844 34.339844 17.625 29.441406 17.621094 C 24.542969 17.53125 19.75 19.703125 16.234375 23.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a344afdd94)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d3e9c3a295)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed08a4cd5b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M 12.492188 20.929688 C 14.3125 18.15625 16.898438 15.867188 19.878906 14.304688 C 22.855469 12.726562 26.257812 11.964844 29.636719 11.992188 C 33.011719 12.070312 36.382812 12.9375 39.324219 14.582031 C 42.261719 16.230469 44.765625 18.609375 46.503906 21.4375 C 44.4375 18.851562 41.875 16.703125 38.972656 15.25 C 36.066406 13.804688 32.855469 12.976562 29.621094 12.972656 C 26.386719 12.867188 23.148438 13.601562 20.210938 14.980469 C 17.265625 16.351562 14.632812 18.40625 12.492188 20.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cc347f5a2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#995dea317b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e4425d1d27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M 8.902344 18.265625 C 11.238281 14.949219 14.410156 12.203125 18.070312 10.371094 C 21.71875 8.523438 25.839844 7.605469 29.9375 7.710938 C 34.03125 7.828125 38.109375 8.914062 41.671875 10.925781 C 45.238281 12.941406 48.265625 15.84375 50.4375 19.269531 C 48.078125 15.976562 44.976562 13.246094 41.445312 11.34375 C 37.902344 9.457031 33.925781 8.398438 29.921875 8.328125 C 25.917969 8.175781 21.898438 9.078125 18.277344 10.796875 C 14.65625 12.523438 11.417969 15.085938 8.902344 18.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#44ce5f6008)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eae3e5904d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f37063b3c9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e140d27e8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff7a59",
    d: "M 4.839844 16.25 C 7.597656 12.261719 11.355469 8.960938 15.679688 6.742188 C 19.988281 4.492188 24.867188 3.335938 29.734375 3.421875 C 34.601562 3.492188 39.4375 4.777344 43.699219 7.117188 C 47.964844 9.453125 51.609375 12.878906 54.253906 16.9375 C 51.527344 12.933594 47.859375 9.582031 43.617188 7.265625 C 39.367188 4.964844 34.554688 3.71875 29.730469 3.675781 C 24.90625 3.566406 20.054688 4.683594 15.757812 6.894531 C 11.453125 9.089844 7.679688 12.320312 4.839844 16.25 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonarLogo);
export default __webpack_public_path__ + "static/media/sonar-logo.647be573cbe42078f62867b4e1342253.svg";
export { ForwardRef as ReactComponent };